import React from "react";
import ReportBoxes from "../../components/student/ReportBoxes";
import Store from "../../stores/StudentReportBoxes";

export default () => {
    const store = new Store();
    return (<ReportBoxes store={store} />)
}